export default __webpack_public_path__ + "static/media/979.56d35b22.png";